// extracted by mini-css-extract-plugin
export var content = "styles-module--content--d780b";
export var ctaButton = "styles-module--ctaButton--c70a1";
export var image = "styles-module--image--d9ed9";
export var imageContainer = "styles-module--imageContainer--d1839";
export var tagline = "styles-module--tagline--46df4";
export var textContainer = "styles-module--textContainer--e9709";
export var textImageOverlap = "styles-module--textImageOverlap--9bec5";
export var title = "styles-module--title--21991";